import { useState } from 'react';

export default function ShareModal({ open, onClose, shareUrl, embedCode }) {
  const [copied, setCopied] = useState('');

  if (!open) return null;

  async function copy(text, key) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(key);
      setTimeout(() => setCopied(''), 1500);
    } catch {
      setCopied('error');
    }
  }

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="card w-full max-w-lg p-6 bg-white" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-3">
          <h2 className="text-lg font-semibold text-atlas-ink">Share this demo</h2>
          <button type="button" aria-label="Close" onClick={onClose} className="text-atlas-muted text-lg leading-none">×</button>
        </div>

        <label className="block text-sm font-medium text-atlas-ink mb-1">Public link</label>
        <div className="flex gap-2">
          <input
            readOnly
            value={shareUrl}
            onFocus={(e) => e.target.select()}
            className="flex-1 border border-atlas-line rounded-md px-3 py-2 text-sm bg-atlas-paper-2 font-mono"
          />
          <button type="button" onClick={() => copy(shareUrl, 'link')} className="btn-primary text-sm">
            {copied === 'link' ? 'Copied' : 'Copy'}
          </button>
        </div>

        <label className="block text-sm font-medium text-atlas-ink mb-1 mt-5">Embed snippet</label>
        <textarea
          readOnly
          value={embedCode}
          onFocus={(e) => e.target.select()}
          rows={3}
          className="w-full border border-atlas-line rounded-md px-3 py-2 text-xs bg-atlas-paper-2 font-mono"
        />
        <div className="flex justify-end mt-2">
          <button type="button" onClick={() => copy(embedCode, 'embed')} className="btn-secondary text-sm">
            {copied === 'embed' ? 'Copied' : 'Copy embed'}
          </button>
        </div>

        <p className="text-xs text-atlas-muted mt-4">
          The share link works in any browser. The embed snippet drops the demo into a 600px iframe.
        </p>
      </div>
    </div>
  );
}
